<app-background-image data-state="terminal-operations"></app-background-image>
<app-topbar></app-topbar>

<nav class="sidebar navbar-dark bg-dark" *ngIf="!isSmallScreen">
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <a class="btn btn-outline-primary btn-block"
               *ngIf="userCan.addOperation"
               (click)="createOperation()">
                New Operation
            </a>
            <a class="btn btn-outline-primary btn-block"
               *ngIf="!userCan.addOperation && userCan.requestOperation"
               (click)="requestOperation()">
                Request an operation
            </a>
        </li>
        <li class="TC mt-2">
            <ng-template #calendarView let-dp>
                <div>
                    <div class="custom-month-grid">
                        @for (month of dp.state.months; track month) {
                        <div class="pt-2 mb-2">
                            <div class="text-primary mb-2">{{ dp.i18n.getMonthFullName(month.month) | titlecase }} {{ month.year }}</div>
                            <ngb-datepicker-month class="border rounded p-2" [month]="month"></ngb-datepicker-month>
                        </div>
                        }
                    </div>
                </div>
            </ng-template>
            <ng-template #footerTemplate>
                <div class="btn-group d-flex justify-content-end mt-3" role="group">
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="datePicker_Navigate(dp, -1)">🠈</button>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="datePicker_Today(dp)">Today</button>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="datePicker_Navigate(dp, 1)">🠊</button>
                </div>
            </ng-template>

            <div class="d-inline-block">
                <ngb-datepicker #dp
                                id="sidebarDatePicker"
                                (dateSelect)="workingDateSelectedFromSidebarDP($event)"
                                [displayMonths]="3"
                                [contentTemplate]="calendarView"
                                outsideDays="collapsed"
                                [weekdays]="false"
                                [showWeekNumbers]="true"
                                [footerTemplate]="footerTemplate"
                                navigation="select" />
            </div>
        </li>
        <li class="mt-4">
            <div class="info-board mb-4 border border-secondary rounded p-1">
                <textarea class="form-control mb-1"
                          rows="3"
                          [(ngModel)]="infoText"
                          placeholder="Enter new info here...">
                </textarea>
                <div class="small"
                     [class.text-danger]="isInfoTooLong"
                     [class.text-muted]="!isInfoTooLong">
                    {{ infoText.length || 0 }} / {{ maxInfoLength }}
                </div>
                <div *ngIf="isInfoTooLong"
                     class="text-danger small">
                    Maximum 255 characters allowed.
                </div>
                <button class="btn btn-primary mt-2"
                        (click)="saveInfo()"
                        [disabled]="isSavingInfo || isInfoTooLong">
                    {{ editingInfo ? 'Update' : 'Save' }}
                </button>
                <button *ngIf="editingInfo"
                        class="btn btn-outline-danger mt-2 ms-2"
                        (click)="cancelEdit()">
                    Cancel
                </button>
            </div>

            <div *ngFor="let info of terminalInfoList"
                 class="info-item mb-3 border border-secondary rounded p-1">
                <div class="text-white fw-bold small">
                    Written by:
                    {{ info.changedByName || info.createdByName || 'Unknown' }}
                </div>
                <div class="text-white text-xs mb-1">
                    Last edit:
                    {{ (info.changedAtUtc || info.createdAtUtc) | date:'dd MMM yyyy HH:mm' }}
                </div>

                <div class="text-white small mb-2 info-description">{{ info.description }}</div>
                <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-primary"
                            (click)="startEdit(info)">
                        Edit
                    </button>

                    <button class="btn btn-outline-danger ms-2"
                            (click)="deleteInfo(info)">
                        Delete
                    </button>
                </div>
            </div>

            <div class="pagination d-flex justify-content-center mt-3">
                <button class="btn btn-secondary btn-sm me-1" (click)="prevInfoPage()" [disabled]="infoPage === 0">◀ Previous</button>
                <span class="align-self-center mx-2">Page {{ infoPage + 1 }}</span>
                <button class="btn btn-secondary btn-sm ms-1" (click)="nextInfoPage()" [disabled]="!infoIsFullPage">Next ▶</button>
            </div>
        </li>
    </ul>
</nav>
<ng-container>
    <div class="main-content">
        <div class="title_operational_dates inline" *ngIf="workingDate">
            <div class="workingDate flex TJ inline">
                <h2>
                    {{ workingDate.weekDay }}
                    {{ workingDate.from | date : "dd / MM - YY" }}
                </h2>
                <input
                    id="DatePicker"
                    type="date"
                    (change)="workingDateSelected($event)"
                />
            </div>
            <hr />
            <h6>
                Last updated: {{ lastFetchedDateTime | date : "dd.MMMM YYYY HH:mm" }} 
                <i
                    class="icon fa-solid fa-arrows-rotate get operations"
                    (click)="fetchOperations()"
                    [ngClass]="{'loading' : false}"
                    title="Click to refresh"
                ></i>
            </h6>
        </div>
        <div class="table-container operations pending mb-4" *ngIf="!isEmpty(pendingOperations) || userCan.listPendingOperations">
            <ng-template #noPendingOperations>
                <h3>{{ operationStatuses.Pending }} {{ operationListTitleSuffix}}</h3>
                <div
                    *ngIf="isLoading(pendingOperations)"
                    class="alert alert-light"
                >
                    <i class="icon fa-solid fa-arrows-rotate loading"></i> Loading...
                </div>
                <div
                    *ngIf="isEmpty(pendingOperations)"
                    class="alert alert-info"
                >
                    No {{ operationStatuses.Pending }} operations recieved.
                </div>
            </ng-template>
            <app-operation-list
                *ngIf="
                    !isEmpty(pendingOperations);
                    else noPendingOperations
                "
                [listTitle]="operationStatuses.Pending + operationListTitleSuffix"
                [listType]="operationStatuses.Pending"
                [operationList]="pendingOperations"
                [rights]="userRightsArr"
                (operationResourcesEvent)="operationResources($event)"
                (editOperationEvent)="editOperation($event)"
                (copyOperationEvent)="copyOperation($event)"
                (acceptOperationEvent)="acceptOperation($event)"
                (updateOperationStatusEvent)="updateOperationStatus($event)"
                (removeOperationEvent)="removeOperation($event)"
            ></app-operation-list>
            <div class="flex TJ">
                <div>
                    <a
                        class="btn btn-secondary btn-sm"
                        *ngIf="userCan.requestOperation"
                        (click)="requestOperation()"
                    >
                        Request an operation
                    </a>
                </div>
            </div>
        </div>
        <div class="table-container operations active">
            <ng-template #noActiveOperations>
                <h3>{{ operationStatuses.Active }} {{ operationListTitleSuffix}}</h3>
                <div
                    *ngIf="!lastFetchedDateStillActual"
                    class="alert alert-light"
                >
                    <i class="icon fa-solid fa-arrows-rotate loading"></i> Loading...
                </div>
                <div
                    *ngIf="isEmpty(activeOperations) && lastFetchedDateStillActual"
                    class="alert alert-info"
                >
                    No {{ operationStatuses.Active }} operations matching search terms.
                </div>
            </ng-template>
            <app-operation-list
                *ngIf="
                    lastFetchedDateStillActual &&
                    !isEmpty(activeOperations);
                    else noActiveOperations
                "
                [listTitle]="operationStatuses.Active + operationListTitleSuffix"
                [listType]="operationStatuses.Active"
                [operationList]="activeOperations"
                [rights]="userRightsArr"
                (editOperationEvent)="editOperation($event)"
                (copyOperationEvent)="copyOperation($event)"
                (operationResourcesEvent)="operationResources($event)"
                (updateOperationStatusEvent)="updateOperationStatus($event)"
                (removeOperationEvent)="removeOperation($event)"
                (rejectOperationEvent)="rejectOperation($event)"
            ></app-operation-list>
            <div class="flex TJ">
                <div>
                    <a
                        class="btn btn-primary btn-sm"
                        *ngIf="userCan.addOperation"
                        (click)="createOperation()"
                    >
                        Add new operation
                    </a>
                </div>
            </div>
        </div>
        <div class="table-container operations completed mt-4" *ngIf="userCan.listCompletedOperations && !isEmpty(completedOperations) && !isSmallScreen">
            <ng-template #noCompletedOperations>
                <h3>{{ operationStatuses.Completed }} {{ operationListTitleSuffix}}</h3>
                <div
                    *ngIf="!lastFetchedDateStillActual"
                    class="alert alert-light"
                >
                    <i class="icon fa-solid fa-arrows-rotate loading"></i> Loading...
                </div>
                <div
                    *ngIf="isEmpty(completedOperations) && lastFetchedDateStillActual"
                    class="alert alert-info"
                >
                    No {{ operationStatuses.Completed }} operations matching search terms.
                </div>
            </ng-template>
            <app-operation-list
                *ngIf="
                    lastFetchedDateStillActual &&
                    !isEmpty(completedOperations);
                    else noCompletedOperations
                "
                [listTitle]="operationStatuses.Completed + operationListTitleSuffix"
                [listType]="operationStatuses.Completed"
                [operationList]="completedOperations"
                [rights]="userRightsArr"
                (editOperationEvent)="editOperation($event)"
                (copyOperationEvent)="copyOperation($event)"
                (operationResourcesEvent)="operationResources($event)"
                (updateOperationStatusEvent)="updateOperationStatus($event)"
                (removeOperationEvent)="removeOperation($event)"
            ></app-operation-list>
        </div>
    </div>
</ng-container>
